var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paused"},[_c('div',[_c('h1',{staticClass:"text-center m-b-1"},[_vm._v("Paused")]),_c('Controls',{attrs:{"context":'pause',"mobile":_vm.mobile},on:{"play":function($event){return _vm.$emit('play')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }